import {FC, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {POST} from '../../../services/api'

const CreateSellerNoSaleReasonContent: FC = () => {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [slugSaleReasonCode, setSlugSaleReasonCode] = useState('')
  const [saleReasonCode, setSaleReasonCode] = useState('')

  const handleSave = async () => {
    if (!slugSaleReasonCode.trim() || !saleReasonCode.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Slug e descrição são obrigatórios',
      })
      return
    }

    setLoading(true)
    try {
      await POST('/seller-no-sale-reason', {
        slugSaleReasonCode: slugSaleReasonCode.trim(),
        saleReasonCode: saleReasonCode.trim(),
      })

      Swal.fire({icon: 'success', title: 'Sucesso', text: 'Motivo criado com sucesso'}).then(() =>
        navigate('/seller/reason')
      )
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: String(error || 'Não foi possível criar o motivo'),
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='row g-5 gx-xxl-12'>
      <div className='card card-xxl-stretch mb-5 mb-xl-12'>
        <div className='card-header py-5'>
          <h3 className='card-title fw-bolder fs-3 mb-0'>Novo Motivo de Não Venda</h3>
        </div>
        <div className='card-body'>
          {loading ? (
            <Loading />
          ) : (
            <div className='d-flex flex-column gap-4'>
              <div>
                <label className='form-label'>Slug</label>
                <input
                  className='form-control'
                  value={slugSaleReasonCode}
                  onChange={(e) => setSlugSaleReasonCode(e.target.value)}
                />
              </div>

              <div>
                <label className='form-label'>Descrição</label>
                <input
                  className='form-control'
                  value={saleReasonCode}
                  onChange={(e) => setSaleReasonCode(e.target.value)}
                />
              </div>

              <div className='d-flex gap-2'>
                <button className='btn btn-primary' type='button' onClick={handleSave}>
                  Salvar
                </button>
                <button className='btn btn-light' type='button' onClick={() => navigate('/seller/reason')}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const CriarSellerNoSaleReason: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Motivos Não Venda', path: '/seller/reason', isActive: false},
          {title: 'Novo Motivo', path: '/seller/reason/create', isActive: true},
        ]}
      >
        Novo Motivo de Não Venda
      </PageTitle>
      <CreateSellerNoSaleReasonContent />
    </>
  )
}

export {CriarSellerNoSaleReason}
